import React, { useContext, useEffect } from 'react';
import Layout from '../../componentes/Plantilla/Plantilla';
import { DataContext } from '../../contexto/ContextoDatos';
import ServiceCard from '../../componentes/Secciones/Servicios/TarjetaServicio';
import styles from './PaginaServicios.module.css';
import logoSeima from '../../recursos/imagenes/logo.webp';
import Breadcrumbs from '../../componentes/UI/Breadcrumbs';

export const ServicesIndex = () => {
  const { services } = useContext(DataContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <section className={styles.hero}>
        <div className="container">
          <div className={styles.heroInner}>
            <Breadcrumbs paths={[{ label: 'Inicio', to: '/' }, { label: 'Servicios' }]} />
            <div className={styles.tituloBloque}>
              <img src={logoSeima} alt="SEIMA" className={styles.logoHero} />
              <h1 className={styles.tituloHero}>
                Nuestros <span className={styles.acento}>Servicios</span>
              </h1>
            </div>
            <div className={styles.lineaHero} />
            <p className={styles.subHero}>
              Soluciones integrales de equipamiento, montaje, mantenimiento y auditorías térmicas.
            </p>
          </div>
        </div>
      </section>

      <section className={styles.listingSection}>
        {services.map((service, index) => (
          <ServiceCard key={service.id} service={service} index={index} />
        ))}
      </section>
    </Layout>
  );
};
export default ServicesIndex;
